// Canonical Texas STAAR performance-level colors, matching the long-standing
// Progress Goals palette (ProgressGoals/ProgressGoalsList/StudentRow.component.js).
// Use these anywhere a performance level is shown so the colors stay consistent
// across the app. Keys are the app's ammCode level identifiers.
export const PERFORMANCE_LEVEL_COLORS = {
  doesNotMeet: '#E06666', // red
  doesNotMeetHigh: '#C27BA0', // mauve (A-F "enhanced" level)
  approaches: '#FF9900', // orange
  approachesHigh: '#B45F06', // dark orange (A-F "enhanced" level)
  meets: '#4A86E8', // blue
  masters: '#38761D', // green
};

// All level chips/cells use white text on the colored background.
export const PERFORMANCE_LEVEL_TEXT_COLOR = '#FFFFFF';

export default PERFORMANCE_LEVEL_COLORS;
